import {useMutation, useQueryClient} from "@tanstack/react-query";
import {
  updateCheckInStatus,
  UpdateCheckInStatusRequestPayload,
} from "./updateCheckInStatus";
import axios from "../../../axios";
import useToast from "../../../../../hooks/useToast";
import {useErrorLogger} from "../../../../../hooks/useErrorLogger";

export function useUpdateCheckInStatus() {
  const qc = useQueryClient();
  const toastInstance = useToast();
  const logError = useErrorLogger();

  return useMutation({
    mutationFn: async (payload: UpdateCheckInStatusRequestPayload) => {
      await updateCheckInStatus(payload, axios);
    },
    onSuccess: (data, payload) => {
      const eventId = String(payload.data.eventId);
      qc.invalidateQueries({queryKey: ["ordersByEvent", eventId]});
      toastInstance.success("Updated check in status");
    },
    onError: (error: any) => {
      toastInstance.error(
        "There was an error on our end, please try again soon"
      );
      logError(error);
    },
  });
}
